function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Business_ic_mid",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h192v192H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 68.58,
  cy: 58.06,
  r: 32.02,
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 137.2,
  cy: 67.21,
  r: 22.87,
  stroke: "#666",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.26 145c5.59-34 25.55-54.82 50.32-54.82a42 42 0 0121.81 6l.35.22M119.23 95.58a31.74 31.74 0 0118-5.5c18 0 32.52 14.43 36.59 38",
  stroke: "#666",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "<Path>",
  cx: 105.18,
  cy: 109.45,
  r: 19.45,
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "<Path>",
  d: "M136.8 163.27c-3.93-22.74-16.94-34.45-31.43-34.45s-27.88 11.71-31.82 34.45",
  stroke: "#e60000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
}));

var SvgFamilyMid = function SvgFamilyMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 192 192",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgFamilyMid;